/* eslint-disable @nx/enforce-module-boundaries */
'use client';
import {
  Avatar,
  Box,
  Container,
  HStack,
  Stack,
  Text,
  Image,
  IconButton,
} from '@mybridge/ui';
import React, { useState, useEffect, useContext } from 'react';
import {
  getUserEducationName,
  getUserExperience,
  getUserFullName,
} from 'v4/lib/commons';
import { isMobile } from 'react-device-detect';
import {
  Button,
  Center,
  CloseButton,
  Divider,
  Flex,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Tooltip,
  useDisclosure,
  VStack,
} from '@chakra-ui/react';
import { ThreeDot, VerticalThreeDot } from '@mybridge/icons';
import { useDispatch, useSelector } from 'react-redux';
import {
  getUserProfileInfo,
  userProfileAddInfo,
} from 'v4/store/actions/user-profile.actions';
import { useRouter } from 'next/router';
import { ProfileFeelingsPicker } from '../profile/feelings-picker';
import { PublicProfileContext } from '../public-profile/context';
import TruncatedTextWithTooltip from '../common/Tooltip';

const ProfileStickyHeader = ({
  profile,
  actions,
  tabsMenu,
  scrollAmount,
  isActive,
  fromPrivate = false,
  ...props
}) => {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(false);
  const [selectedFeeling, setSelectedFeeling] = useState();
  const [loading, setLoading] = useState(false);
  const feelingDisc = useDisclosure();
  const { userProfileInfo, profilePDFUrl } = useSelector(
    (state) => state.userProfile
  );
  const { publicProfile, experiences, educations } = useContext(PublicProfileContext);
  const { feelings_activity } = userProfileInfo || {};
  const userExperience = getUserExperience(publicProfile ? { experiences } : userProfileInfo);
  const userEducation = getUserEducationName(publicProfile ? { educations } : userProfileInfo);
  const { feelingsAndActivities } = useSelector((s) => s.globalData) ?? {};

  const dispatch = useDispatch();

  const getFeelingActivityGrammer = (category) => {
    switch (category) {
      case 'More':
        return '';
      case 'Attending':
        return 'Attending ';
      case 'Celebrating':
        return 'Celebrating ';
      case 'Feeling':
        return 'Feeling ';
      default:
        return '';
    }
  };

  const updateFeelingsData = () => {
    const formData = {};
    formData['feelings'] = selectedFeeling?.id;
    setLoading(true);
    dispatch(userProfileAddInfo(formData, true))
      .then((res) => {
        dispatch(getUserProfileInfo());
        // setLoading(false);
        // setIsOpen(false);
        // setSelectedFeeling();
      })
      .catch((e) => setLoading(false));
  };
  useEffect(() => {
    if (selectedFeeling) updateFeelingsData();
  }, [selectedFeeling]);
  const startDate =
    userExperience?.start_month === '0'
      ? `Jan ${userExperience?.start_year}`
      : `${new Date(
          userExperience?.start_year,
          userExperience?.start_month - 1,
          1
        ).toLocaleString('default', { month: 'short' })} ${
          userExperience?.start_year
        }`;

  const endDate = userExperience?.currently_working
    ? 'Present'
    : `${new Date(
        userExperience?.end_year,
        userExperience?.end_month - 1,
        1
      ).toLocaleString('default', { month: 'short' })} ${
        userExperience?.end_year
      }`;

  useEffect(() => {
    const handleScroll = () => {
      if (isMobile ? window.scrollY > 400 : window.scrollY > 640) {
        setIsVisible(true);
        isActive(true);
      } else {
        setIsVisible(false);
        isActive(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const removeSetFeeling = () => {
    const formData = {};
    formData['feelings'] = '';
    setLoading(true);
    dispatch(userProfileAddInfo(formData, true))
      .then((res) => {
        dispatch(getUserProfileInfo());
        // setLoading(false);
        // setIsOpen(false);
        setSelectedFeeling();
      })
      .catch((e) => setLoading(false));
  };

  //   console.log(window.scrollY);
  return (
    // <Box
    //   display={isVisible ? 'block' : 'none'}
    //   pos="sticky"
    //   top="64px"
    //   zIndex="8"
    //   {...props}
    // >
    //   <Box
    //     bg="white"
    //     // boxShadow="0px 2px 6px 0px #00000033"
    //     pos="relative"
    //     zIndex="8"
    //   >
    //     <Container maxW="1220px">
    //       <Stack
    //         direction={['column', 'row']}
    //         justifyContent="space-between"
    //         pb={[3, 0]}
    //       >
    //         <HStack p={3} _hover={{ bg: '#F2F2F2' }} cursor="pointer">
    //           <Avatar
    //             src={profile?.profile_pic}
    //             name={`${profile?.first_name} ${profile?.last_name}`}
    //             size="md"
    //           />
    //           <Text fontSize="20px" fontWeight="600" color="brandPrimary.500">
    //             {getUserFullName(profile)}{' '}
    //             {profile?.pronouns && !profile?.pronouns.includes(null)
    //               ? `(${profile?.pronouns})`
    //               : ``}
    //           </Text>
    //         </HStack>

    //           {feelings_activity && (
    //             <Box
    //               borderRadius="full"
    //               px={3}
    //               py={1}
    //               height={'100%'}
    //               mt={4}
    //               marg
    //               className="primaryGradiantButton"
    //             >
    //               <HStack>
    //                 <Flex
    //                   width="25px"
    //                   height="25px"
    //                   bg="white"
    //                   borderRadius="full"
    //                   justifyContent="center"
    //                   alignItems="center"
    //                 >
    //                   <Image
    //                     src={feelings_activity?.file}
    //                     width="22"
    //                     height="22"
    //                   />
    //                 </Flex>
    //                 <Text color="#fff" fontSize="14px">
    //                   {getFeelingActivityGrammer(feelings_activity?.category)}
    //                   {feelings_activity?.name}
    //                 </Text>
    //                 <Center height="14px">
    //                   <Divider
    //                     orientation="vertical"
    //                     borderColor="white"
    //                     opacity="1"
    //                   />
    //                 </Center>
    //                 <Tooltip label="Remove">
    //                   <CloseButton
    //                     color="white"
    //                     size="sm"
    //                     onClick={() => removeSetFeeling()}
    //                   />
    //                 </Tooltip>
    //               </HStack>
    //             </Box>
    //           )}
    //         <Menu zIndex="5">
    //           <MenuButton>
    //             <VerticalThreeDot height="20px" />
    //           </MenuButton>
    //           <Portal>
    //             <MenuList zIndex={10}>
    //               <MenuItem
    //                 onClick={() =>
    //                   router.push('/p/' + userProfileInfo?.slug)
    //                 }

    //               >
    //                 View as Public
    //               </MenuItem>
    //               <MenuItem>Save to PDF</MenuItem>
    //             </MenuList>
    //           </Portal>
    //         </Menu>
    // {/* <HStack>{actions}</HStack> */}
    //       </Stack>
    //     </Container>
    //     <Divider />
    //   </Box>
    //   {tabsMenu ? (
    //     <Box
    //       bg="white"
    //       // boxShadow="0px 2px 6px 0px #00000033"
    //       pos="relative"
    //       zIndex="5"
    //       p={3}
    //       pb={0}
    //       mt={"0px"}
    //     >
    //       <Container maxW="1220px">{tabsMenu}</Container>
    //     </Box>
    //   ) : (
    //     <></>
    //   )}
    // </Box>
    <Box
      display={isVisible ? 'block' : 'none'}
      pos="sticky"
      top="64px"
      zIndex="8"
      {...props}
    >
      <Box
        bg="white"
        boxShadow="0px 2px 6px 0px #00000033"
        pos="relative"
        zIndex="8"
      >
        <Container pt={'1px'} pl={0} maxW="1220px">
          <Flex
            pt={1}
            direction={['column', 'row']}
            justifyContent="space-between"
            // alignItems="center"
            pb={[3, 0]}
            alignItems="start"
          >
            {/* Left Section */}
            <HStack
              alignItems="start"
              width="auto"
              p={3}
              _hover={{ bg: '#F2F2F2' }}
              cursor="pointer"
            >
              <Avatar
                src={profile?.profile_pic}
                name={`${profile?.first_name} ${profile?.last_name}`}
                size="lg"
              />
              <VStack alignItems="start">
                <Text
                  fontSize="20px"
                  display={getUserFullName(profile)?.length < 20 ? 'flex' : ''}
                  gap={2}
                  alignItems="center"
                  whiteSpace="nowrap"
                  fontWeight="400"
                  maxW="260px"
                  lineHeight="18px"
                  color="#3D5A80"
                >
                  {TruncatedTextWithTooltip({
                    text: getUserFullName(profile),
                    maxChars: 20,
                  })}{' '}
                  {profile?.pronouns && !profile?.pronouns.includes(null)
                    ? `(${profile?.pronouns})`
                    : ``}
                </Text>
                <Box alignItems="baseline">
                  {userExperience?.id ? (
                    <>
                      <Text gap={0} alignItems="start" display="inline">
                        {userExperience?.title} at{' '}
                      </Text>
                      <Text fontWeight="bold">
                        {userExperience?.company_name}
                      </Text>
                    </>
                  ) : userEducation?.id ? (
                    <>
                      <Text display="inline">Student at </Text>
                      <Text display="inline" fontWeight="bold">
                        {userEducation?.name}
                      </Text>
                    </>
                  ) : (
                    ''
                  )}
                </Box>
              </VStack>
            </HStack>

            {/* Right Section */}
            <Flex direction={'column-reverse'} gap={4} spacing={4}>
              {!selectedFeeling &&
                userProfileInfo?.id === publicProfile?.id &&
                !(
                  router.pathname.includes('/p/') &&
                  router.asPath.split('/').pop() === userProfileInfo?.slug
                ) && ( // Conditionally render Popover if no feeling is selected
                  <Popover {...feelingDisc}>
                    <PopoverTrigger>
                      <Button
                        bg="white"
                        color="#868585"
                        borderRadius="27px"
                        border="1px solid #00000033"
                        _hover={{
                          bg: '#E4E6EB',
                          color: '#5B5B5B',
                          borderColor: '1px',
                        }}
                        leftIcon={
                          selectedFeeling ? (
                            <Image
                              src={selectedFeeling?.file}
                              width="22"
                              height="22"
                            />
                          ) : (
                            <></>
                          )
                        }
                      >
                        {selectedFeeling
                          ? selectedFeeling?.name
                          : 'What is going on?'}
                      </Button>
                    </PopoverTrigger>
                    <Portal>
                      <PopoverContent w="md">
                        <PopoverBody p={4} w="100%">
                          {feelingsAndActivities && (
                            <ProfileFeelingsPicker
                              setFeeling={(value) => {
                                feelingDisc?.onClose();
                                setSelectedFeeling(value);
                              }}
                              onClickClose={(e) => {
                                if (e) feelingDisc?.onClose();
                              }}
                            />
                          )}
                        </PopoverBody>
                      </PopoverContent>
                    </Portal>
                  </Popover>
                )}
              {(fromPrivate
                ? feelings_activity
                : publicProfile?.feelings_activity) && (
                <Box
                  borderRadius="full"
                  px={3}
                  py={1}
                  w={"max-content"}
                  alignSelf={'end'}
                  className="primaryGradiantButton"
                >
                  <HStack>
                    <Flex
                      width="25px"
                      height="25px"
                      bg="white"
                      borderRadius="full"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <Image
                        src={
                          publicProfile?.feelings_activity?.file ??
                          feelings_activity?.file
                        }
                        width="22"
                        height="22"
                        alt=""
                      />
                    </Flex>
                    <Text color="#fff" fontSize="14px">
                      {getFeelingActivityGrammer(
                        publicProfile?.feelings_activity?.feeling_category ??
                          feelings_activity?.feeling_category
                      )}
                      {publicProfile?.feelings_activity?.name ??
                        feelings_activity?.name}
                    </Text>
                    {!!fromPrivate && (
                      <Center height="14px">
                        <Divider
                          orientation="vertical"
                          borderColor="white"
                          opacity="1"
                        />
                      </Center>
                    )}
                    {!!fromPrivate && (
                      <Tooltip label="Remove">
                        <CloseButton
                          color="white"
                          size="sm"
                          onClick={() => removeSetFeeling()}
                        />
                      </Tooltip>
                    )}
                  </HStack>
                </Box>
              )}
              {userProfileInfo?.id !== publicProfile?.id && (
                <HStack justifyContent={'end'}>{actions}</HStack>
              )}

              {/* <Menu zIndex="5">

                <MenuButton
                  as={IconButton}
                  icon={<ThreeDot />}
                  sx={{
                    borderRadius: '27px ',
                    border: '1px solid #00000033',
                    backgroundColor: 'transparent',
                    color: 'inherit',
                    _hover: {
                      backgroundColor: '#E4E6EB',
                      color: 'inherit',
                    },
                    _focus: {
                      backgroundColor: 'white',
                      color: 'inherit',
                    },
                  }}
                />


                <Portal>
                  <MenuList zIndex={10}>
                    <MenuItem
                      onClick={() =>
                        router.push('/p/' + userProfileInfo?.slug)
                      }
                    >
                      View as Public
                    </MenuItem>
                    <MenuItem>Save to PDF</MenuItem>
                  </MenuList>
                </Portal>
              </Menu> */}
            </Flex >
          </Flex>
        </Container>
        <Divider />
      </Box>
      {tabsMenu ? (
        <Box
          bg="white"
          boxShadow="0px 2px 6px 0px #00000033"
          pos="relative"
          zIndex="5"
          p={3}
          pb={0}
        >
          <Container maxW="1220px">{tabsMenu}</Container>
        </Box>
      ) : null}
    </Box>
  );
};

export default ProfileStickyHeader;
